import { isValidDateString } from "@/common/utils/dateValidator"
import { z } from "zod"

const geoOptionSchema = z.object({
  label: z.custom<string | JSX.Element>(),
  value: z.string(),
  type: z.string()
}, { message: 'Campo obrigatório' })

export const createSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  date: z.string({ message: 'Campo obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato DD/MM/AAAA' })
    .refine(isValidDateString, { message: 'Data inválida' }),
  description: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(512, { message: 'Tamanho máximo: 512 caracteres' }),
  geo: geoOptionSchema,
  blocks_establishment_payment_advances: z.boolean(),
})

export type HolidayValidationSchema = z.infer<typeof createSchema>
